<div class="attribute-field">
  @if (attributes?.length > 0) {
    <div class="form-floating form-attribute" *ifScreenSize="ScreenType.Desktop">
      @for (value of innerValue; track value.RewardAttributeId) {
        <select
          class="form-select init-padding"
          id="attrSelect"
          [(ngModel)]="selectedAttribute"
          [disabled]="control?.disabled"
          (change)="onAttributeChange()"
        >
          <option selected disabled class="default-option">
            {{ 'marketplace.attribute.button' | translate }} {{ value?.DisplayName }}
          </option>
          @for (attribute of value.Values; track attribute?.AttributeMappingId) {
            <option
              class="attribute-option"
              [value]="attribute?.AttributeMappingId"
              [disabled]="!attribute?.UnlimitedStock && attribute?.AvailableStockCount == 0"
            >
              {{ attribute?.DisplayName }}
            </option>
          }
        </select>
        <label class="form-attribute-label" for="attrSelect" [class.none-selected]="!selectedAttribute">
          {{ 'marketplace.attribute.button' | translate }} {{ value?.DisplayName }}
        </label>
      }
    </div>
    @for (value of innerValue; track value.RewardAttributeId) {
      <button
        *ifScreenSize="ScreenType.Mobile"
        class="btn btn-select-attribute"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasAttribute"
        aria-controls="offcanvasAttribute"
        (click)="addStyleBackdrop()"
      >
        @if (!selectedAttribute) {
          <div>{{ 'marketplace.attribute.button' | translate }} {{ value?.DisplayName }}</div>
        } @else if (selectedAttribute) {
          <div class="mobile-select-attribute">
            <label class="selected-label">{{ 'marketplace.attribute.button' | translate }} {{ value?.DisplayName }}</label>
            <span>{{ selectedAttributeName }}</span>
          </div>
        }
        <div class="material-icons">arrow_forward_ios</div>
      </button>

      <div
        class="offcanvas offcanvas-attribute offcanvas-bottom"
        tabindex="-1"
        id="offcanvasAttribute"
        aria-labelledby="offcanvasAttributeLabel"
      >
        <div class="offcanvas-header">
          <div class="offcanvas-attributes-title fw-bold" id="offcanvasAttributeLabel">
            {{ 'marketplace.attribute.button' | translate }} {{ value?.DisplayName }}
          </div>
          <button type="button" class="btn-close material-icons" data-bs-dismiss="offcanvas">close</button>
        </div>
        <div class="offcanvas-body">
          @for (attribute of value.Values; track attribute?.AttributeMappingId) {
            <button
              class="offcanvas-attribute-btn"
              [disabled]="!attribute?.UnlimitedStock && attribute?.AvailableStockCount == 0"
              (click)="onCanvasAttributeSelect(attribute?.AttributeMappingId)"
              [ngClass]="{
                'offcanvas-attribute-btn-disabled': !attribute?.UnlimitedStock && attribute?.AvailableStockCount == 0,
                'offcanvas-attribute-btn-active': attribute?.AttributeMappingId == selectedAttribute,
              }"
              data-bs-dismiss="offcanvas"
            >
              {{ attribute?.DisplayName }}
            </button>
          }
        </div>
      </div>
    }
  }
</div>
